import { Card, styled } from "@mui/material";

const FlatCard = styled(Card)(() => ({
  boxShadow: "none",
}));

export default FlatCard;
